import { render } from "./Changelog.vue?vue&type=template&id=af80f024&scoped=true&ts=true&lang=pug"
import script from "./Changelog.vue?vue&type=script&lang=ts"
export * from "./Changelog.vue?vue&type=script&lang=ts"

import "./Changelog.vue?vue&type=style&index=0&id=af80f024&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af80f024"]])

export default __exports__